export const APP_VERSION =
  // tslint:disable-next-line
  process.env['REACT_APP_BUILD_VERSION'] ||
  process.env.REACT_APP_BUILD_VERSION ||
  import.meta.env.REACT_APP_VERSION! ||
  build.REACT_APP_VERSION ||
  '0.0.0.DEV';

/*
 * build.REACT_APP_VERSION is defined at build time (vite.config.ts)
 * you could override it with env. variable REACT_APP_VERSION if you'd like to
 */

// export const APP_VERSION = import.meta.env.REACT_APP_VERSION!;
// export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN!;
